export const homeMatchResignationSurveyOptions = [
    {
        value: "1",
        label: "Oferty nie spełniają moich oczekiwań"
    },
    {
        value: "2",
        label: "Nie jestem zainteresowany taką usługą"
    },
    {
        value: "3",
        label: "Znalazłem już mieszkanie"
    },
    {
        value: "4",
        label: "Otrzymuję za dużo ofert"
    }
];
export const homeMatchResignationSurveyOptions = [
    {
        value: "1",
        label: "Oferty nie spełniają moich oczekiwań"
    },
    {
        value: "2",
        label: "Nie jestem zainteresowany taką usługą"
    },
    {
        value: "3",
        label: "Znalazłem już mieszkanie"
    },
    {
        value: "4",
        label: "Otrzymuję za dużo ofert"
    }
];
